import React, { useEffect, useState } from 'react';
import classname from 'classnames';
import PropTypes from 'prop-types';

import range from 'lodash/range';
import map from 'lodash/map';
import OperatorsDropdown from '../OperatorDropdown/OperatorDropdown';

function OperatorSelection({ node, updateOperator, operators }) {
  const [selectedOperator, onSelectionOperator] = useState({
    label: node?.operator ? node?.operator : node?.defaultOperation,
    operatorQualifier: node?.operatorQualifier ? node?.operatorQualifier : '',
  });
  const [operatorQualifierList, setOperatorQualifierList] = useState([]);
  const [operatorQualifierValue, setOperatorQualifierValue] = useState(node.operatorQualifier ? node.operatorQualifier : '');

  /** On Refresh we don't have operatorQualifierList, so we need to fetch it */
  useEffect(() => {
    const operatorSelected = operators?.find((operator) => operator.label === selectedOperator.label);
    if (operatorSelected && operatorSelected.supportsQualifier) {
      const operatorQualifiers = map(range(operatorSelected.lowerQualifierBound, operatorSelected.upperQualifierBound + 1), (num) => ({
        id: num,
        label: num,
      }));
      setOperatorQualifierList(operatorQualifiers);
    }
  }, [selectedOperator, operators]);

  const onOperatorChange = (s) => {
    onSelectionOperator(s);
    if (s.supportsQualifier) {
      const operatorQualifiers = map(range(s.lowerQualifierBound, s.upperQualifierBound + 1), (num) => ({ id: num, label: num }));
      setOperatorQualifierList(operatorQualifiers);
      setOperatorQualifierValue(s.defaultQualifier);
    }
    updateOperator({ operator: s.label, qualifier: s.defaultQualifier, node });
  };
  const operatorSupportsQualifier = (operator) => {
    const operatorData = operators?.find((op) => op.label === operator);
    return operatorData?.supportsQualifier || false;
  };
  return (
    <div
      className={classname('ql__operator', {
        'ql__operator__with-qualifier': node.operatorQualifier || operatorSupportsQualifier(node.operator),
      })}>
      {selectedOperator && selectedOperator.label && (
        <OperatorsDropdown
          options={operators}
          selected={{ label: selectedOperator.label }}
          onChange={(s) => {
            onOperatorChange(s);
          }}
          buttonProps={{
            type: 'link',
            'aria-label': `Boolean operators, current value: ${selectedOperator.label}`,
          }}
        />
      )}
      {selectedOperator && (selectedOperator.supportsQualifier || selectedOperator.operatorQualifier) && (
        <OperatorsDropdown
          options={operatorQualifierList}
          selected={{ label: operatorQualifierValue }}
          onChange={(s) => {
            setOperatorQualifierValue(s.label);
            updateOperator({ operator: selectedOperator.label, qualifier: s.label, node });
          }}
          buttonProps={{
            type: 'link',
            'aria-label': `Boolean operator qualifier, current value: ${operatorQualifierValue}`,
          }}
        />
      )}
    </div>
  );
}

OperatorSelection.propTypes = {
  node: PropTypes.object,
  updateOperator: PropTypes.func,
  operators: PropTypes.array,
};

export default OperatorSelection;
